import { FC } from "react";
import styles from "./buttonCheckout.module.css";

const ButtonCheckout: FC<{
  action: any;
  label: string;
  backgroundColor: string;
  color: string;
  marginBottom?: boolean;
}> = ({ label, action, color, backgroundColor, marginBottom }) => {
  return (
    <div
      className={styles.button}
      style={marginBottom ? { bottom: "5em" } : { bottom: "0em" }}
    >
      <button
        onClick={() => action && action()}
        style={{
          backgroundColor: backgroundColor,
          color: color,
        }}
      >
        {label}
      </button>
    </div>
  );
};

export { ButtonCheckout };
